export const CATALOG_PER_PAGE = 96
